import FeatureToggle, { Feature } from "./FeatureToggle";

export { Feature, FeatureToggle };